import { Action } from '@ngrx/store';
import { BirthdateFormat, Onboarding } from './onboarding.models';
import { StepsManager } from './utils/steps.manager';
import { StepsManagerV2 } from './utils/steps.manager-v2';

export enum OnboardingActionTypes {
  SET_EMAIL = '[OnboardingAction] Set email',
  SET_PASSWORD = '[OnboardingAction] Set password',
  ACCOUNT_EXISTS = '[OnboardingAction] Account exists',
  LOAD_ONBOARDING = '[OnboardingAction] Load onboarding',
  LOAD_ONBOARDING_FAILED = '[OnboardingAction] Load onboarding failed',
  LOAD_ONBOARDING_SUCCESS = '[OnboardingAction] Load onboarding success',
  LOAD_ONBOARDING_TOS_ITEM_DETAILS = '[OnboardingAction] Load TOS item details',
  LOAD_ONBOARDING_TOS_ITEM_DETAILS_FAILED = '[OnboardingAction] Load TOS item details failed',
  LOAD_ONBOARDING_TOS_ITEM_DETAILS_SUCCESS = '[OnboardingAction] Load TOS item details success',
  PASSWORD_RESET = '[OnboardingAction] Password reset',
  PASSWORD_RESET_FAILED = '[OnboardingAction] Password reset failed',
  PASSWORD_RESET_SUCCESS = '[OnboardingAction] Password reset success',
  PASSWORD_RESET_COMPLETED = '[OnboardingAction] Password reset completed',
  PASSWORD_RESET_FOR_ID = '[OnboardingAction] Password reset for ID',
  PASSWORD_RESET_FOR_ID_FAILED = '[OnboardingAction] Password reset for ID failed',
  PASSWORD_RESET_FOR_ID_BIRTHDATE_ERROR = '[OnboardingAction] Password reset for ID birthday error',
  CHANGE_PASSWORD = '[OnboardingAction] Change password',
  CHANGE_PASSWORD_FAILED = '[OnboardingAction] Change password failed',
  CHANGE_PASSWORD_SUCCESS = '[OnboardingAction] Change password success',
  SEND_STEP = '[OnboardingAction] Send step',
  SEND_STEP_FAILED = '[OnboardingAction] Send step failed',
  SEND_STEP_SUCCESS = '[OnboardingAction] Send step success',
  SEND_STEP_V2 = '[OnboardingAction] Send step v2',
  SEND_STEP_V2_FAILED = '[OnboardingAction] Send step v2 failed',
  SEND_STEP_V2_SUCCESS = '[OnboardingAction] Send step v2 success',
  FINALIZE_ONBOARDING = '[OnboardingAction] Finalize onboarding',
  FINALIZE_ONBOARDING_FAILED = '[OnboardingAction] Finalize onboarding failed',
  FINALIZE_ONBOARDING_SUCCESS = '[OnboardingAction] Finalize onboarding success',
  ONBOARDING_COMPLETED = '[OnboardingAction] Onboarding completed',
  SET_SELECTED_TOS_INDEX = '[OnboardingAction] Set selected TOS index',
  SET_BIRTHDATE = '[OnboardingAction] Set birthdate',
  SET_BIRTHDATE_FORMAT = '[OnboardingAction] Set birthdate format',
  SET_BIRTHDATE_LABEL = '[OnboardingAction] Set birthdate label',
  SET_BIRTHDATE_BUTTON = '[OnboardingAction] Set birthdate button',
  TRUSTED_DEVICE_POPUP = '[OnboardingAction] Trusted device popup',
  SET_LOGIN_TITLE = '[OnboardingAction] Set login title',
  LOAD_BIOMETRIC = '[OnboardingAction] Load Biometric',
  LOAD_BIOMETRIC_FAILED = '[OnboardingAction] Load Biometric failed',
  SET_BIOMETRIC_LOGIN = '[OnboardingAction] Set biometric login',
  SET_BIRTHDATE_LANGUAGE = '[OnboardingAction] Set birthdate language',
  SET_SWIPER_NAVIGATE_TO = '[OnboardingAction] Set swiper navigate to',
  SET_EMAIL_FORGOT_PASSWORD = '[OnboardingAction] Set email forgot password'
}

export class OnboardingActionSetEmail implements Action {
  readonly type = OnboardingActionTypes.SET_EMAIL;

  constructor(public payload: string) {}
}

export class OnboardingActionSetPassword implements Action {
  readonly type = OnboardingActionTypes.SET_PASSWORD;

  constructor(public payload: string) {}
}

export class OnboardingActionAccountExists implements Action {
  readonly type = OnboardingActionTypes.ACCOUNT_EXISTS;

  constructor(public payload: boolean) {}
}

export class OnboardingActionLoadOnboarding implements Action {
  readonly type = OnboardingActionTypes.LOAD_ONBOARDING;
}

export class OnboardingActionLoadOnboardingFailed implements Action {
  readonly type = OnboardingActionTypes.LOAD_ONBOARDING_FAILED;
}

export class OnboardingActionLoadOnboardingSuccess implements Action {
  readonly type = OnboardingActionTypes.LOAD_ONBOARDING_SUCCESS;

  constructor(public payload: Onboarding) {}
}

export class OnboardingActionLoadTosItemDetails implements Action {
  readonly type = OnboardingActionTypes.LOAD_ONBOARDING_TOS_ITEM_DETAILS;

  constructor(public payload: string) {}
}

export class OnboardingActionLoadTosItemDetailsFailed implements Action {
  readonly type = OnboardingActionTypes.LOAD_ONBOARDING_TOS_ITEM_DETAILS_FAILED;
}

export class OnboardingActionLoadTosItemDetailsSuccess implements Action {
  readonly type =
    OnboardingActionTypes.LOAD_ONBOARDING_TOS_ITEM_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class OnboardingActionPasswordReset implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET;

  constructor(public payload: any) {}
}

export class OnboardingActionPasswordResetFailed implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET_FAILED;
}

export class OnboardingActionPasswordResetSuccess implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET_SUCCESS;

  constructor(public payload: any) {}
}

export class OnboardingActionPasswordResetCompleted implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET_COMPLETED;
}

export class OnboardingActionPasswordResetForId implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET_FOR_ID;

  constructor(public payload: string) {}
}

export class OnboardingActionPasswordResetForIdFailed implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET_FOR_ID_FAILED;
}

export class OnboardingActionPasswordResetBirthdateError implements Action {
  readonly type = OnboardingActionTypes.PASSWORD_RESET_FOR_ID_BIRTHDATE_ERROR;
}

export class OnboardingActionChangePassword implements Action {
  readonly type = OnboardingActionTypes.CHANGE_PASSWORD;

  constructor(public payload: string) {}
}

export class OnboardingActionChangePasswordFailed implements Action {
  readonly type = OnboardingActionTypes.CHANGE_PASSWORD_FAILED;
}

export class OnboardingActionChangePasswordSuccess implements Action {
  readonly type = OnboardingActionTypes.CHANGE_PASSWORD_SUCCESS;
}

export class OnboardingActionSendStep implements Action {
  readonly type = OnboardingActionTypes.SEND_STEP;

  constructor(public payload: StepsManager) {}
}

export class OnboardingActionSendStepFailed implements Action {
  readonly type = OnboardingActionTypes.SEND_STEP_FAILED;
}

export class OnboardingActionSendStepSuccess implements Action {
  readonly type = OnboardingActionTypes.SEND_STEP_SUCCESS;

  constructor(public payload: StepsManager) {}
}

export class OnboardingActionSendStepV2 implements Action {
  readonly type = OnboardingActionTypes.SEND_STEP_V2;

  constructor(public payload: StepsManagerV2) {}
}

export class OnboardingActionTrustedDevicePopup implements Action {
  readonly type = OnboardingActionTypes.TRUSTED_DEVICE_POPUP;

  constructor(public payload: any) {}
}

export class OnboardingActionSendStepV2Failed implements Action {
  readonly type = OnboardingActionTypes.SEND_STEP_V2_FAILED;
}

export class OnboardingActionSendStepV2Success implements Action {
  readonly type = OnboardingActionTypes.SEND_STEP_V2_SUCCESS;

  constructor(public payload: StepsManagerV2) {}
}

export class OnboardingActionFinalizeOnboarding implements Action {
  readonly type = OnboardingActionTypes.FINALIZE_ONBOARDING;

  constructor(public payload: StepsManager) {}
}

export class OnboardingActionFinalizeOnboardingFailed implements Action {
  readonly type = OnboardingActionTypes.FINALIZE_ONBOARDING_FAILED;
}

export class OnboardingActionFinalizeOnboardingSuccess implements Action {
  readonly type = OnboardingActionTypes.FINALIZE_ONBOARDING_SUCCESS;

  constructor(public payload: StepsManager) {}
}

export class OnboardingActionOnboardingCompleted implements Action {
  readonly type = OnboardingActionTypes.ONBOARDING_COMPLETED;
}

export class OnboardingActionSetSelectedTosIndex implements Action {
  readonly type = OnboardingActionTypes.SET_SELECTED_TOS_INDEX;

  constructor(public payload: number) {}
}

export class OnboardingActionSetBirthdate implements Action {
  readonly type = OnboardingActionTypes.SET_BIRTHDATE;

  constructor(public payload: string) {}
}

export class OnboardingActionSetBirthdateFormat implements Action {
  readonly type = OnboardingActionTypes.SET_BIRTHDATE_FORMAT;

  constructor(public payload: BirthdateFormat) {}
}

export class OnboardingActionSetBirthdateLabel implements Action {
  readonly type = OnboardingActionTypes.SET_BIRTHDATE_LABEL;

  constructor(public payload: string) {}
}

export class OnboardingActionSetBirthdateButton implements Action {
  readonly type = OnboardingActionTypes.SET_BIRTHDATE_BUTTON;

  constructor(public payload: string) {}
}

export class OnboardingActionSetLoginTitle implements Action {
  readonly type = OnboardingActionTypes.SET_LOGIN_TITLE;

  constructor(public payload: string) {}
}

export class OnboardingActionLoadBiometric implements Action {
  readonly type = OnboardingActionTypes.LOAD_BIOMETRIC;
}

export class OnboardingActionLoadBiometricFailed implements Action {
  readonly type = OnboardingActionTypes.LOAD_BIOMETRIC_FAILED;

  constructor(public payload: any) {}
}

export class OnboardingActionSetBiometricLogin implements Action {
  readonly type = OnboardingActionTypes.SET_BIOMETRIC_LOGIN;

  constructor(public payload: any) {}
}

export class OnboardingActionSetBirthdateLanguage implements Action {
  readonly type = OnboardingActionTypes.SET_BIRTHDATE_LANGUAGE;

  constructor(public payload: string) {}
}

export class OnboardingActionSetSwiperNavigateTo implements Action {
  readonly type = OnboardingActionTypes.SET_SWIPER_NAVIGATE_TO;

  constructor(public payload: any) {}
}

export class OnboardingActionSetEmailForgotPassword implements Action {
  readonly type = OnboardingActionTypes.SET_EMAIL_FORGOT_PASSWORD;

  constructor(public payload: string) {}
}

export type OnboardingActions =
  | OnboardingActionSetEmail
  | OnboardingActionSetPassword
  | OnboardingActionAccountExists
  | OnboardingActionLoadOnboarding
  | OnboardingActionLoadOnboardingFailed
  | OnboardingActionLoadOnboardingSuccess
  | OnboardingActionLoadTosItemDetails
  | OnboardingActionLoadTosItemDetailsFailed
  | OnboardingActionLoadTosItemDetailsSuccess
  | OnboardingActionPasswordReset
  | OnboardingActionPasswordResetFailed
  | OnboardingActionPasswordResetSuccess
  | OnboardingActionPasswordResetCompleted
  | OnboardingActionChangePassword
  | OnboardingActionChangePasswordFailed
  | OnboardingActionChangePasswordSuccess
  | OnboardingActionSendStep
  | OnboardingActionSendStepFailed
  | OnboardingActionSendStepSuccess
  | OnboardingActionSendStepV2
  | OnboardingActionSendStepV2Failed
  | OnboardingActionSendStepV2Success
  | OnboardingActionFinalizeOnboarding
  | OnboardingActionFinalizeOnboardingFailed
  | OnboardingActionFinalizeOnboardingSuccess
  | OnboardingActionOnboardingCompleted
  | OnboardingActionSetSelectedTosIndex
  | OnboardingActionPasswordResetForId
  | OnboardingActionPasswordResetForIdFailed
  | OnboardingActionPasswordResetBirthdateError
  | OnboardingActionSetBirthdate
  | OnboardingActionSetBirthdateFormat
  | OnboardingActionSetBirthdateLabel
  | OnboardingActionSetBirthdateButton
  | OnboardingActionTrustedDevicePopup
  | OnboardingActionSetLoginTitle
  | OnboardingActionLoadBiometric
  | OnboardingActionLoadBiometricFailed
  | OnboardingActionSetBiometricLogin
  | OnboardingActionSetBirthdateLanguage
  | OnboardingActionSetSwiperNavigateTo
  | OnboardingActionSetEmailForgotPassword;
